import get from 'lodash/get'
import _ from 'lodash'

export const favoriteBottles = (state, getters, rootState) => {
  const finishedTastings = []
  _.forIn(get(rootState, ['completion', 'tasting'], {}), (value, key) => {
    if ('complete' in value && value.complete) {
      finishedTastings.push({
        id: key,
        complete: true,
        rating: value.rating
      })
    }
  })

  // Get the liked tastings
  const likedTasting = finishedTastings.filter(el => el.rating && el.rating >= 4).map(el => {
    return Object.assign({}, getters.getTastingById(el.id), {
      rating: el.rating
    })
  })

  // Retrieve each bottle liked based on the liked tasting
  return likedTasting
    .map(tasting => ({
      tasting: tasting,
      bottle: getters.getBottleById(tasting.bottleId),
      rating: tasting.rating
    }))
    .filter(favorite => favorite.bottle && favorite.rating)
    .sort((record1, record2) => record2.rating - record1.rating)
}

export const getBottles = state => state.bottles

export const getBottleById = state => id => {
  return state.bottles.find(el => el.id === id)
}
